import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { User } from '@app/core/business/user/user';
import { UserService } from '@app/core/business/user/user.service';
import { AuthenticationService } from '@app/core/business/user/authentication.service';
import { TranslationService } from '@app/core/service/translation.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent implements OnInit {
    @Input()
    theme = 'dark';
    
    @Input()
    userCode: string;

    user: User;

    constructor(
        private userService: UserService,
        private authenticationService: AuthenticationService,
        private translationService: TranslationService
    ) {}

    ngOnInit() {
        this.onInit();
    }

  

    onInit(){
        this.userService
        .getUser$()
        .subscribe(user => {
            this.user = user;
            // If no language is set for the session, use defaultLanguage from user
            if (!this.translationService.getActiveLanguage().value) {
            this.translationService.setActiveLanguage(
                this.user.preferences.defaultLanguage
            );
            }
        });
    }
}
